import { Schema } from '@core/data/dto/schema';

export const DocumentSchema = {
    id: Schema.String,
    year: Schema.Number,
    type: Schema.String,
    description: Schema.String,
    quarter: Schema.String,
    label: Schema.String,
    date: Schema.Moment,
    filed_on: Schema.Moment,
    provider: Schema.String,
    provider_id: Schema.String,
    title: Schema.String,
    jurisdiction: Schema.String,
    status: Schema.Auto
}
